<template>
  <div class="testPaperSetting">
    <el-card>
      <el-row :gutter="20" v-auth="'testPaperSetting_/examSetting/pageList'">
        <el-col :sm="12" :md="5" :lg="5">
          <el-cascader
            clearable
            style="width: 100%"
            v-model="searchForm.courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请选择所属课程"
            :options="subjectTreeList"
            @change="subjectChangePageList(searchForm.courseIds)"
          ></el-cascader>
        </el-col>
        <el-col :sm="12" :md="5" :lg="5">
          <el-select
            style="width: 100%"
            clearable
            v-model="searchForm.examSettingId"
            placeholder="请选择考试期数"
            @change=";(page.pageNumber = 1), pageList()"
          >
            <el-option
              v-for="item in examSettingList"
              :key="item.id"
              :label="'第' + item.sequence + '期'"
              :value="item.sequence"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
    </el-card>
    <el-card class="box-card">
      <el-row :span="24">
        <el-col :span="12">
          <el-button
            type="primary"
            @click="callBackToProjectPhaseItemList"
            icon="el-icon-plus"
            v-auth="'testPaperSetting_/examSetting/addExamSetting'"
          >添加到阶段内容中
          </el-button
          >
        </el-col>
        <el-col :span="12" style="text-align: right">
          <el-button
            type="primary"
            @click="addFormVisible = true"
            icon="el-icon-plus"
            v-auth="'testPaperSetting_/examSetting/addExamSetting'"
          >添加考试
          </el-button
          >
          <el-button
            type="primary"
            @click="cleanQuestionByExamCache()"
            v-auth="'testPaperSetting_/question/cleanQuestionByExamCache'"
          >清除试卷缓存
          </el-button
          >
        </el-col>
      </el-row>

      <el-table
        height="350"
        @selection-change="handleSelectionChange"
        v-auth="'testPaperSetting_/examSetting/pageList'"
        ref="multipleTable"
        :data="page.rows"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%"
        border
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="subjectCourse.name"
          label="考试课程"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="resourceDescription"
          label="考试期数"
        >
          <template slot-scope="slot">第{{ slot.row.sequence }}期</template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="examSettingRelationList"
          label="试卷"
        >
          <template slot-scope="slot">
            <span
              v-if="slot.row.examSettingRelationCount == 0"
              class="testPaperSetting-text3"
              @click="goExamSetting(slot.row)"
            >未设置考卷</span
            >
            <el-button type="text" v-else>
              <span
                v-if="slot.row.examSettingRelationList[0].exam != null"
                @click="goDoWork(slot.row)"
              >{{ slot.row.examSettingRelationList[0].exam.name }}</span
              >
              <span v-else @click="goExamSetting(slot.row)">未设置考卷</span>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="examType"
          label="考试类型"
          width="250"
        >
          <template slot-scope="slot">
            <span v-if="slot.row.examType == 1">仿真模考</span>
            <span v-if="slot.row.examType == 2">随到随考</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="remark"
          label="考试时间"
          width="250"
        >
          <template slot-scope="slot">
            <span
            >{{ slot.row.examBeginTime }}-{{
                slot.row.examEndTime.split(' ')[1]
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="state"
          label="状态"
          width="120"
          align="center"
          :render-header="renderSpecNameHeader"
        >
          <template slot-scope="slot">
            <span v-if="slot.row.examState == 1">未开始</span>
            <span v-if="slot.row.examState == 2">考试中</span>
            <span v-if="slot.row.examState == 3" style="color: #a2aabc"
            >已结束</span
            >
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop
          label="操作"
          width="120"
          align="center"
        >
          <template slot-scope="scope">
            <div class="operationGroup">
              <el-button
                v-if="scope.row.state != 3"
                type="text"
                @click="goExamSetting(scope.row)"
                v-auth="'testPaperSetting_fullExamSetting'"
              >设置
              </el-button
              >
              <el-button
                v-if="scope.row.state == 3"
                type="text"
                @click="goExamSetting(scope.row)"
              >查看
              </el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-auth="'testPaperSetting_/examSetting/pageList'"
        background
        layout="prev, pager, next, jumper,  total, sizes"
        style="margin-top: 20px; text-align: left"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>
    <el-dialog
      class="addDialog"
      title="添加考试"
      width="500px"
      :visible.sync="addFormVisible"
    >
      <el-form
        :model="addForm"
        status-icon
        :rules="rules"
        ref="addForm"
        label-width="80px"
      >
        <el-form-item label="考试课程" prop="courseIds">
          <el-cascader
            clearable
            style="width: 100%"
            v-model="addForm.courseIds"
            :show-all-levels="false"
            :props="subjectTreeProps"
            placeholder="请选择考试课程"
            :options="subjectCourseTreeList"
            @change="subjectChangeById(addForm.courseIds)"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="考试期数">
          <el-input v-model="sequence" disabled></el-input>
        </el-form-item>
        <el-form-item label="考试类型">
          <el-select
            style="width: 100%"
            clearable
            v-model="addForm.examType"
            placeholder="请选择考试类型"
          >
            <el-option
              v-for="item in examType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试时长" v-if="addForm.examType == 2">
          <el-input type="number" v-model="addForm.newDuration"></el-input>
        </el-form-item>

        <el-form-item label="报名时间" prop="date">
          <el-date-picker
            style="width: 100%"
            v-model="addForm.date"
            type="datetimerange"
            arrow-control
            :picker-options="pickerOptions"
            range-separator="至"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="考试日期" prop="examTime">
          <el-row>
            <el-col :span="24">
              <el-date-picker
                style="width: 100%"
                v-model="addForm.examTime"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-col>
            <!-- <el-col :span="12" style="float:right">
              <el-time-picker
                style="width:100%"
                is-range
                value-format="HH:mm"
                format="HH:mm"
                v-model="addForm.period"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              ></el-time-picker>
            </el-col> -->
          </el-row>
        </el-form-item>
        <el-form-item label="考试时间" prop="endTime">
          <!-- <el-time-picker
            style="width:100%"
            is-range
            value-format="HH:mm"
            format="HH:mm"
            v-model="addForm.period"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          ></el-time-picker> -->
          <el-row>
            <el-col :span="11">
              <el-time-select
                style="width: 100%"
                placeholder="起始时间"
                v-model="addForm.beginTime"
                :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '24:00',
                }"
              ></el-time-select>
            </el-col>
            <el-col :span="2">
              <div class="time-selectType">至</div>
            </el-col>
            <el-col :span="11">
              <el-time-select
                style="width: 100%"
                placeholder="结束时间"
                v-model="addForm.endTime"
                :picker-options="{
                  start: '06:00',
                  step: '00:15',
                  end: '24:00',
                  minTime: addForm.beginTime,
                }"
              ></el-time-select>
            </el-col>
          </el-row>
        </el-form-item>

        <el-form-item style="text-align: right">
          <el-button @click="addFormVisible = false">取消</el-button>
          <el-button type="primary" @click="addExamSetting">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import SelectHeader from "./SelectHeader";

export default {
  data() {
    return {
      multipleSelection: [],
      blockAddLiveRoom: false,
      activeName: "first",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      },
      pickerOptions: {
        disabledDate(time) {
          var times = Date.now() - 24 * 60 * 60 * 1000;
          return time.getTime() < times;
        },
      },
      classInfoList: [],
      subjectTreeList: [],
      subjectTreeProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      subjectCourseTreeList: [],
      addFormVisible: false,
      editFormVisible: false,
      searchForm: {},
      pageSearchForm: {},
      examState: "",
      addForm: {
        endTime: "",
        beginTime: "",
      },
      examSettingList: [],
      examType: [
        {
          id: '1',
          name: '仿真模考'
        }, {
          id: '2',
          name: '随到随考'
        }],
      visible: false,
      editForm: {
        resource: [],
      },
      formLabelWidth: "80px",
      sequence: "",
      loading: false,
      rules: {
        courseIds: [
          {
            required: true,
            message: "请选择考试课程",
            trigger: "change",
          },
        ],
        sequence: [
          {
            required: true,
            message: "请选择考试期数",
            trigger: "change",
          },
        ],
        examTime: [
          {
            required: true,
            message: "请选择考试日期",
            trigger: "change",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择考试时间",
            trigger: "change",
          },
        ],
        date: [
          {
            required: true,
            message: "请选择报名时间",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    callBackToProjectPhaseItemList() {
      if(this.multipleSelection.length === 0) {
        this.$message.error('请选择需要添加的考试')
        return
      }
      this.$emit('getExamSettingList', this.multipleSelection)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    goExamSetting(row) {
      localStorage.setItem("jump", JSON.stringify(row));
      this.$router.push({path: "/fullExamSetting"});
    },
    subjectChangePageList(val) {
      this.searchForm.examSettingId = "";
      this.page.pageNumber = 1;
      this.pageList();
      this.subjectChange(val);
    },
    renderSpecNameHeader(createElement, {column, $index}) {
      let self = this;

      //该列的绑定数据
      // console.log(column);
      //列号
      // console.log($index);

      return createElement(
        "div",
        {
          style: "display:flex;padding:0px;margin-left:30px",
        },
        [
          createElement("div", {
            domProps: {
              innerHTML: column.label,
            },
          }),
          createElement(SelectHeader, {
            style: "cursor: pointer;",
            // 组件 prop
            props: {
              type: "specId",
              options: self.specIdOptions, //下拉框选项
              defaultValue: self.specId, //默认值
              defaultProps: {
                value: "specId",
                label: "specName",
              },
            },
            // 事件监听器在 `on` 属性内，
            // 但不再支持如 `v-on:keyup.enter` 这样的修饰器。
            // 需要在处理函数中手动检查 keyCode。
            on: {
              selectChange: self.selectChange,
              // click: this.clickHandler
            },
            // 仅用于组件，用于监听原生事件，而不是组件内部使用
            // `vm.$emit` 触发的事件。
            nativeOn: {
              // click: this.nativeClickHandler
            },
          }),
        ]
      );
    },
    //选择框回调
    selectChange(val) {
      this.examState = val;
      this.pageList();
      //写点啥吧
    },
    getAgentRoleInfo(id) {
      this.api.agentRoleInfo
        .getAgentRoleInfo({
          id: id,
        })
        .then((result) => {
          this.editForm = result.data;
          this.editFormVisible = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    goDoWork(item) {
      this.$router.push({
        path: "/doWork",
        query: {id: item.id, examId: item.examSettingRelationList[0].examId},
      });
    },
    getSubjectCourseExamCount() {
      this.api.examSetting
        .getSubjectCourseExamCount()
        .then((result) => {
          if (result.success) {
            this.subjectTreeList = result.data;
            // this.searchForm.courseIds = this.subjectTreeList[0].children[0].children[0].id;
            this.pageList();
            // this.getExamSettingList(this.searchForm.courseIds);
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getSubjectCourseTreeList() {
      this.api
        .getSubjectCourseTreeList()
        .then((result) => {
          if (result.success) {
            this.subjectCourseTreeList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cleanQuestionByExamCache() {
      this.api.question.cleanQuestionByExamCache().then((result) => {
        if (result.success) {
          sessionStorage.clear();
          this.$message.success(result.message);
        } else {
          this.$message(result.message);
        }
      });
    },
    subjectChangeById(item) {
      if (typeof item == "object") {
        this.generateSequence(item[2]);
      }
    },
    generateSequence(courseId) {
      this.api.examSetting
        .generateSequence({courseId: courseId})
        .then((result) => {
          if (result.success) {
            this.addForm.sequence = result.data;
            this.sequence = "第" + this.addForm.sequence + "期";
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    subjectChange(item) {
      if (typeof item == "object") {
        this.getExamSettingList(item[2]);
        this.searchForm.examSettingId = "";
        this.questionPage.rows = [];
        this.examList = [];
      }
    },
    getExamSettingList(courseId) {
      this.api.examSetting
        .getExamSettingList({courseId: courseId})
        .then((result) => {
          if (result.success) {
            this.examSettingList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // queryPageList(val) {
    //   this.loading = true;
    //   this.pageSearchForm.pageSize = this.page.pageSize;
    //   this.pageSearchForm.pageNumber = 1;
    //   if (this.examState!=""&&this.examState) {
    //     this.pageSearchForm.examState = this.examState;
    //   }
    //   if (this.searchForm.examSettingId != "") {
    //     this.pageSearchForm.sequence = this.searchForm.examSettingId;
    //   }
    //   if (typeof this.searchForm.courseIds == "object") {
    //     this.pageSearchForm.courseId = this.searchForm.courseIds[2];
    //   } else {
    //     this.pageSearchForm.courseId = this.searchForm.courseIds;
    //   }
    //   this.api.examSetting
    //     .pageList(this.pageSearchForm)
    //     .then(result => {
    //       this.loading = false;
    //       this.pageSearchForm = {};
    //       this.page.rows = result.data.records;
    //       this.page.total = result.data.total;
    //       this.page.pageNumber = 1;
    //     })
    //     .catch(error => {
    //       console.log(error);
    //     });
    // },
    pageList(val) {
      this.loading = true;
      this.pageSearchForm.pageSize = this.page.pageSize;
      this.pageSearchForm.pageNumber = this.page.pageNumber;
      if (this.examState != "" && this.examState) {
        this.pageSearchForm.examState = this.examState;
      }
      if (this.searchForm.examSettingId != "") {
        this.pageSearchForm.sequence = this.searchForm.examSettingId;
      }
      if (typeof this.searchForm.courseIds == "object") {
        this.pageSearchForm.courseId = this.searchForm.courseIds[2];
      } else {
        this.pageSearchForm.courseId = this.searchForm.courseIds;
      }
      this.api.examSetting
        .pageList(this.pageSearchForm)
        .then((result) => {
          this.loading = false;
          this.pageSearchForm = {};
          this.page.rows = result.data.records;
          this.page.total = result.data.total;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    addExamSetting() {
      if (this.blockAddLiveRoom) {
        return false;
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.blockAddLiveRoom = true;
          this.addForm.courseId = this.addForm.courseIds[2];
          this.addForm.examBeginTime =
            this.addForm.examTime + " " + this.addForm.beginTime;
          this.addForm.examEndTime = this.addForm.examTime + " " + this.addForm.endTime;
          this.addForm.signBeginTime = this.addForm.date[0];
          this.addForm.signEndTime = this.addForm.date[1];
          this.api.examSetting
            .addExamSetting(this.addForm)
            .then((result) => {
              if (result.success) {
                this.addFormVisible = false;
                this.blockAddLiveRoom = false;
              } else {
                this.blockAddLiveRoom = false;
                this.$message.error(result.message);
              }
              this.getSubjectCourseExamCount();
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    deleteExamSetting(row) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then(() => {
          this.api.examSetting
            .deleteExamSetting([
              {
                id: row.id,
              },
            ])
            .then((result) => {
              if (result.success) {
                this.$message({
                  type: "success",
                  message: result.message,
                });
                const totalPage = Math.ceil((this.page.total - 1) / this.page.pageSize);
                const pagenum =
                  this.page.pageNumber > totalPage ? totalPage : this.page.pageNumber;
                this.page.pageNumber = pagenum < 1 ? 1 : pagenum;
                this.pageList();
              } else {
                this.$message.error(result.message);
              }
            })
            .catch((error) => {
              console.log(error);
            });
        })
        .catch(() => {
        });
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.page.pageSize = 10;
      this.page.pageNumber = 1;
      this.page.sortName = "";
      this.page.sortOrder = "";
      this.page = {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "",
        sortOrder: "",
      };
      this.pageList();
    },
    getClassInfoList(id) {
      this.api.classInfo
        .getClassInfoList({campusId: id})
        .then((result) => {
          if (result.success) {
            this.classInfoList = result.data;
          } else {
            this.$message.error(result.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleClick(tab, event) {
      this.getSubjectTreeList();
      this.getClassInfoList();
    },
    getMobiles() {
      this.mobiles = [];
      this.addForm.name.replace(/[&\|\\\*^%$#@\-]/g, "").trim();
      let zs = /^[1-9]\d*|0$/;
      let names = "";
      for (var index in this.addForm.name) {
        if (zs.test(this.addForm.name[index])) {
          names = this.addForm.name[index] + names;
        }
      }

      names = names.split("").reverse().join("").split("");
      for (var i = 10; i < names.length; i += 11) names[i] += " ";
      names = names.join("");
      let arr = names.split(" ");
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      arr.forEach((element) => {
        if (!mobile.test(element)) {
          if (element) {
            this.$message.error(element + "格式不正确！！！");
          }
        } else {
          let addSty = true;
          this.mobiles.forEach((item) => {
            if (item == element) {
              this.$message.warning(element + "此电话号码已存在！！！");
              addSty = false;
            }
          });
          if (addSty) {
            this.mobiles.push(element);
          }
        }
      });
    },
    filterExamState(value, row) {
      return row.examState == value;
    },
    getMobiless() {
      this.mobiles = [];
      this.addForm.name.replace(/[&\|\\\*^%$#@\-]/g, "").trim();
      let zs = /^[1-9]\d*|0$/;
      let names = "";
      for (var index in this.addForm.name) {
        if (zs.test(this.addForm.name[index])) {
          names = this.addForm.name[index] + names;
        }
      }

      names = names.split("").reverse().join("").split("");
      for (var i = 10; i < names.length; i += 11) names[i] += " ";
      names = names.join("");
      let arr = names.split(" ");
      let mobile = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      arr.forEach((element) => {
        if (!mobile.test(element)) {
          if (element) {
            this.$message.error(element + "格式不正确！！！");
          }
        } else {
          let addSty = true;
          this.mobiles.forEach((item) => {
            if (item == element) {
              this.$message.warning(element + "此电话号码已存在！！！");
              addSty = false;
            }
          });
          if (addSty) {
            this.mobiles.push(element);
          }
        }
      });
    },
  },
  watch: {
    addFormVisible: function (newVal) {
      if (!newVal) {
        this.$refs.addForm.resetFields();
        this.sequence = "";
        this.addForm = {};
        this.getSubjectCourseExamCount();
      } else {
      }
    },
  },
  mounted() {
    this.getSubjectCourseExamCount();
    this.getSubjectCourseTreeList();
    this.pageList();
  },
};
</script>
<style scoped>
.testPaperSetting-text {
  line-height: 40px;
  font-size: 14px;
}

.testPaperSetting-text2 {
  line-height: 40px;
  font-size: 14px;
  color: #4d94ff;
}

.testPaperSetting-text3 {
  color: red;
}

.testPaperSetting-addStudent {
  margin-top: 20px;
  text-align: right;
}

.testPaperSetting-color {
  color: #409eff;
}

.time-selectType {
  text-align: center;
  width: 100%;
  line-height: 40px;
}
</style>
<style lang="less" rel="stylesheet/less">
.testPaperSetting {
  .addDialog {
    .el-dialog__body {
      padding-top: 10px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/project/testPaperSetting.vue